import { render, staticRenderFns } from "./Epg.vue?vue&type=template&id=18aea7ac&scoped=true&"
import script from "./Epg.vue?vue&type=script&lang=js&"
export * from "./Epg.vue?vue&type=script&lang=js&"
import style0 from "./Epg.vue?vue&type=style&index=0&id=18aea7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aea7ac",
  null
  
)

export default component.exports